'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttleApi = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Throttle calls to an API.  The first call must complete before the subsequent call is started.
 *
 * @param {Function} func async function to call.  This function must return a promise
 * @returns {Promise}
 */
var throttleApi = exports.throttleApi = function throttleApi(func) {
  var previousCall = _q2.default.Promise.resolve();

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var callNext = function callNext() {
      return func.apply(undefined, args);
    };
    previousCall = previousCall.then(callNext, callNext);
    return previousCall;
  };
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/utils/throttleApi.js
// module id = 408
// module chunks = 2 3